import React from 'react';
export var PageInfo = /*#__PURE__*/React.createContext({});